import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useQuery } from 'react-query';
import Spinner from '../../../Component/Spinner/Spinner';
import useScrollToTop from '../../../hooks/useScrollToTop';
import useTitle from '../../../hooks/useTitle';
import ConfirmationModal from '../../Shared/ConfirmationModal/ConfirmationModal';
import ErrorMessage from '../../Shared/ErrorMessage/ErrorMessage';

const AllBuyer = () => {
    const [deletingBuyer, setDeletingBuyer] = useState(null);
    const [errorMessages, setErrorMessages] = useState("");

    useScrollToTop();
    useTitle("Buyers");

    const closeModal = () => {
        setDeletingBuyer(null);
    }

    const {data: buyer = [], refetch, isLoading} = useQuery({
        queryKey: ['buyer'],
        queryFn: async () => {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/users?role=buyer`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    authorization: `bearer ${localStorage.getItem('token')}`
                }
            })
            const data = res.json();
            if (data.success) {
                setErrorMessages("");
                return data.data;
            } else {
                setErrorMessages(data.error);
                return [];
            }
        }
    })
    
    const handleDeleteBuyer = buyer => {
        fetch(`${process.env.REACT_APP_API_URL}/users/buyer/${buyer._id}`, {
            method: 'DELETE',
            headers: {
                authorization: `bearer ${localStorage.getItem('token')}`
            }
        })
        .then(res => res.json())
        .then(data => {
            if(data.deletedCount > 0)
            refetch();
            toast.success(`User ${buyer.name} deleted successfully`)

        })
    }

    if (isLoading) {
        return <Spinner />
    }

    if (errorMessages) {
        return <ErrorMessage error={errorMessages} />;
    }

    return (
        <div className='mx-10'>
            <h1 className="text-2xl">all buyers</h1>
            <div className="overflow-x-auto w-full">
                <table className="w-full whitespace-no-wrap">
                    {/* <!-- head --> */}
                    <thead>
                        <tr className="text-xs font-semibold tracking-wide text-left text-gray-700 uppercase border-b dark:border-gray-700 bg-gray-300 dark:text-gray-400 dark:bg-black">
                            <th className="px-4 py-3">Image</th>
                            <th className="px-4 py-3">Name</th>
                            <th className="px-4 py-3">Email</th>
                            <th className="px-4 py-3">Status</th>
                            <th className="px-4 py-3">Join Date</th>
                            <th className="px-4 py-3">Delete Action</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-900">
                        {buyer.map((buy) => (
                            <tr key={buy._id}>
                                <td className="px-4 py-3 ">
                                    <div className="flex items-center space-x-3">
                                        <div className="avatar">
                                            <div className="mask mask-squircle w-12 h-12">
                                                <img
                                                    src={buy.image}
                                                    alt={buy.name}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-4 py-3 ">
                                    <div>
                                        <div className="font-bold">{buy.name}</div>
                                    </div>
                                </td>
                                <td className="px-4 py-3 ">{buy.email}</td>
                                <td className="px-4 py-3 text-xs">
                                    {
                                        buy?.isVerified === true ? (
                                            <span className="px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-full dark:bg-green-700 dark:text-green-100">Verified</span>
                                        ) : (
                                            <span className="px-2 py-1 font-semibold leading-tight text-orange-700 bg-orange-100 rounded-full dark:text-white dark:bg-orange-600">Not verified</span>
                                        )
                                    }
                                </td>
                                <td className="px-4 py-3 ">{buy.joinDate}</td>
                                <th>
                                    <label
                                        onClick={() => setDeletingBuyer(buy)}
                                        htmlFor="confirmation-modal"
                                        className='btn btn-error btn-xs'
                                    >
                                        Delete
                                    </label>
                                </th>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {
                deletingBuyer && <ConfirmationModal
                    title={`Are you sure you want to delete?`}
                    message={`If you delete ${deletingBuyer.name}. It cannot be undone.`}
                    successAction={handleDeleteBuyer}
                    successButtonName="Delete"
                    modalData={deletingBuyer}
                    closeModal={closeModal}
                >
                </ConfirmationModal>
            }
        </div>
    );
};

export default AllBuyer;